import { createSelector } from 'reselect';

import { State } from '@wetransfer/transfer/store/types';

import { TransferWindowDrawerState } from './types';

export const selectTransferWindowDrawerState = (
  state: State
): TransferWindowDrawerState => state.transferWindowDrawer;

export const selectIsTransferWindowDrawerOpen = createSelector(
  selectTransferWindowDrawerState,
  (state): boolean => state.isDrawerOpen
);
